import(/* webpackMode: "eager" */ "/vercel/path0/app/terms/page.jsx")